import { ResetPassword } from 'components/templates';
import React from 'react';

import { LoginViewBox } from './styles';

export const ResetPasswordView = () => {
  const params = new URLSearchParams(window.location.search);
  const confirmationCode = params.get('confirmationCode');

  return (
    <LoginViewBox>
      <ResetPassword confirmationCode={confirmationCode as string} />
    </LoginViewBox>
  );
};
